import { Box, HStack } from '../../../Core';
import { Text } from '../../../Text';

export function WorkflowHeaderTitle({ title }: { title: string }) {
  return (
    <HStack
      gap="spacing12"
      minWidth={0}
      maxWidth="100%"
      flex="1"
      overflow="hidden"
      justifyContent="flex-start"
      alignItems="center"
    >
      <Text data-testid="title-text" fontWeight="500" fontSize="fontSizeDefault" lineHeight="1">
        {title}
      </Text>
      <Box
        data-testid="title-chip"
        px="spacing10"
        py="spacing6"
        background="backgroundDefaultButton"
        borderRadius="borderRadiusDefault"
        display="flex"
        alignItems="center"
        justifyContent="center"
        minWidth="44px"
      >
        <Text color="colors.gray.090" textTransform="uppercase" fontSize="fontSizeTiny" fontWeight="500" lineHeight="1">
          NEW
        </Text>
      </Box>
    </HStack>
  );
}
